import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { Modal } from "MODULES/shared/components";
import { Close, Header } from "MODULES/shared/components/Modal";
import { RECEIVING_CHECKLIST_QUESTIONS } from "MODULES/Receiving/constants";
import pojo from "LIB/pojos";
import Form from "./Form";

function Edit({ open, close, receivingRecord }) {
  const initialValues = pojo(receivingRecord).pick(
    ...Object.keys(RECEIVING_CHECKLIST_QUESTIONS)
  );

  return (
    <Modal open={open} close={close} dialogClass="modal-md">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Edit Receiving Checklist</h4>
      </Header>
      <Form close={close} initialValues={initialValues} enableReinitialize />
    </Modal>
  );
}

Edit.propTypes = {
  close: T.func.isRequired,
  open: T.func.isRequired,
  receivingRecord: T.shape({})
};

export default connect(state => ({
  receivingRecord: state.receivingRecordDetail.get("receivingRecord").toJS()
}))(Edit);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/EditQuestionsChecklist/Edit.jsx